var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsupportedBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5026 15.9159H1.56744C2.35289 9.22273 8.05606 4.02778 14.9759 4.02778C22.4329 4.02778 28.4766 10.0603 28.4766 17.5C28.4766 24.9397 22.4329 30.9722 14.9759 30.9722C8.05606 30.9722 2.35289 25.7773 1.56744 19.0841H19.5026H19.9192V18.6675V16.3325V15.9159H19.5026Z",
    fill: "url(#paint0_linear_595_403)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.5026 15.9159H1.56744C2.35289 9.22273 8.05606 4.02778 14.9759 4.02778C22.4329 4.02778 28.4766 10.0603 28.4766 17.5C28.4766 24.9397 22.4329 30.9722 14.9759 30.9722C8.05606 30.9722 2.35289 25.7773 1.56744 19.0841H19.5026H19.9192V18.6675V16.3325V15.9159H19.5026Z",
    stroke: "url(#paint1_linear_595_403)",
    strokeWidth: 0.833333,
    style: {
      mixBlendMode: "plus-lighter"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_595_403",
    x1: 15.0001,
    y1: 3.61111,
    x2: 15.0001,
    y2: 31.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_595_403",
    x1: 15.0001,
    y1: 3.61111,
    x2: 15.0001,
    y2: 31.3889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.07
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupportedBase);
export default __webpack_public_path__ + "static/media/unsupportedBase.9381e17cc26224e34037f9d2c665775a.svg";
export { ForwardRef as ReactComponent };